import axios from "@/app/Axios";
//import routerProtected from "@/app/routerProtected";
class Menus {
    async menuget() {
        try {
            const response = await axios.get("/menus");
            if (response && response.data) {
                return { status: true, records: response.data };
            } else {
                console.error("Respuesta inválida o sin registros.");
                return { status: false, records: [] };
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                return { status: false, message: error.response.data.message };
            } else {
                console.log(error);
                return { status: false, message: "Error interno del servidor" };
            }
        }
    }
    async submenuget() {
        try {
            const response = await axios.get("/submenus");
            if (response && response.data) {
                return { status: true, records: response.data };
            } else {
                console.error("Respuesta inválida o sin registros.");
                return { status: false, records: [] };
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                return { status: false, message: error.response.data.message };
            } else {
                console.log(error);
                return { status: false, message: "Error interno del servidor" };
            }
        }
    }
    async getmenus() {
        try {
            const response = await axios.get("/getmenus");
            if (response && response.data) {
                return { status: true, records: response.data };
            } else {
                console.error("Respuesta inválida o sin registros.");
                return { status: false, records: [] };
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                return { status: false, message: error.response.data.message };
            } else {
                console.log(error);
                return { status: false, message: "Error interno del servidor" };
            }
        }
    }
    async pruebamenuget() {
        try {
            const response = await axios.get("/menusget");
            if (response && response.data) {
                return { status: true, records: response.data };
            } else {
                console.error("Respuesta inválida o sin registros.");
                return { status: false, records: [] };
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                return { status: false, message: error.response.data.message };
            } else {
                console.log(error);
                return { status: false, message: "Error interno del servidor" };
            }
        }
    }
    async pruebasubmenuget() {
        try {
            const response = await axios.get("/submenusget");
            if (response && response.data) {
                return { status: true, records: response.data };
            } else {
                console.error("Respuesta inválida o sin registros.");
                return { status: false, records: [] };
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                return { status: false, message: error.response.data.message };
            } else {
                console.log(error);
                return { status: false, message: "Error interno del servidor" };
            }
        }
    }
    async registrarmenu(menus) {
        try {
            const response = await axios.post("/postmenus", menus);
            console.log("Respuesta de Servicio menus",response);
            return response.data;
        } catch (error) {
            console.log(error);
            return { status: false, message: "Error interno del servidor" };
        }
    }
    async modificarmenus(menus) {
        try {
          const response = await axios.put(
            `/putmenus/${menus.id}`,
            menus
          );
          return response.data;
        } catch (error) {
          if (error.response && error.response.status === 401) {
            return error.response.data;
          } else {
            console.log(error);
          }
        }
      }
      async emilimarmenus(id) {
        try {
            const response = await axios.delete(`/deletemenus/${id}`);
            return response.data;
        } catch (error) {
            if (error.response && error.response.status === 401) {
                return error.response.data;
            } else {
                console.log(error);
            }
        }
    }
    //MENU ROLES
    async menurolesget() {
        try {
            const response = await axios.get("/getmenuroles");
            if (response && response.data) {
                return { status: true, records: response.data };
            } else {
                console.error("Respuesta inválida o sin registros.");
                return { status: false, records: [] };
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                return { status: false, message: error.response.data.message };
            } else {
                console.log(error);
                return { status: false, message: "Error interno del servidor" };
            }
        }
    }
    async selectindex() {
        try {
            const response = await axios.get("/getmenus"); 
            if (response.status === 200) {
                console.log("datos menus", response.data);
                return response.data;
                
            } else {
                console.error("Error al cargar datos desde la API");
                return [];
            }
        } catch (error) {
            console.error("Error al cargar opciones desde la API:", error);
            return [];
        }
    }
    async registrarmenuroles(menuroles) {
        try {
            const response = await axios.post("/postmenuroles", menuroles);
            console.log("Respuesta de Servicio roles",response);
            return response.data;
        } catch (error) {
            console.log(error);
            return { status: false, message: "Error interno del servidor" };
        }
    }
    async modificarmenuroles(menuroles) {
        try {
          const response = await axios.put(
            `/putmenuroles/${menuroles.id}`,
            menuroles
          );
          return response.data;
        } catch (error) {
          if (error.response && error.response.status === 401) {
            return error.response.data;
          } else {
            console.log(error);
          }
        }
      }
      async eliminarmenuroles(id) {
        try {
            const response = await axios.delete(`/deletemenuroles/${id}`);
            console.log("Es el dato a eliminar", response.data);
            return response.data;

        } catch (error) {
            if (error.response && error.response.status === 401) {
                return error.response.data;
            } else {
                console.log(error);
            }
        }
    }
    async rolusermenuget() {
        try {
            const response = await axios.get("/getMenuUserRole");
            if (response && response.data) {
                return { status: true, records: response.data };
            } else {
                console.error("Respuesta inválida o sin registros.");
                return { status: false, records: [] };
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                return { status: false, message: error.response.data.message };
            } else {
                console.log(error);
                return { status: false, message: "Error interno del servidor" };
            }
        }
    }
    async rolusersubmenuget() {
        try {
            const response = await axios.get("/getSubMenuUserRole");
            if (response && response.data) {
                return { status: true, records: response.data };
            } else {
                console.error("Respuesta inválida o sin registros.");
                return { status: false, records: [] };
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                return { status: false, message: error.response.data.message };
            } else {
                console.log(error);
                return { status: false, message: "Error interno del servidor" };
            }
        }
    }
      
    
}
export default Menus;